/* EVFINA — observation cursor, slow reveals, plate displacement,
   the X discount reveal, and the password gate. Motion stays near-invisible. */
(function () {
  'use strict';

  function cursor() {
    if (!window.matchMedia || !window.matchMedia('(pointer:fine)').matches) return;
    var c = document.querySelector('.evf-cursor');
    if (!c) return;
    var dot = c.querySelector('.dot'), x = c.querySelector('.x'), t = c.querySelector('.target');
    document.body.classList.add('evf-cursor-on');
    c.style.display = 'block';
    var tx = innerWidth / 2, ty = innerHeight / 2, cx = tx, cy = ty, mode = 'point';
    addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      var host = e.target.closest ? e.target.closest('[data-cursor]') : null;
      var m = host ? host.getAttribute('data-cursor') : 'point';
      if (m !== mode) {
        mode = m;
        dot.style.opacity = m === 'point' ? '1' : '0';
        x.style.opacity = m === 'x' ? '1' : '0';
        t.style.opacity = m === 'target' ? '1' : '0';
      }
      var plate = e.target.closest ? e.target.closest('[data-shift]') : null;
      if (plate) {
        var layer = plate.querySelector('img') || plate.querySelector('.evf-frame__border');
        if (layer) {
          var r = plate.getBoundingClientRect();
          var dx = ((e.clientX - r.left) / r.width - 0.5) * -12;
          var dy = ((e.clientY - r.top) / r.height - 0.5) * -9;
          layer.style.transform = 'translate(' + dx.toFixed(2) + 'px,' + dy.toFixed(2) + 'px)';
        }
      }
    }, { passive: true });
    (function loop() {
      cx += (tx - cx) * 0.24; cy += (ty - cy) * 0.24;
      c.style.transform = 'translate(' + cx.toFixed(2) + 'px,' + cy.toFixed(2) + 'px)';
      requestAnimationFrame(loop);
    })();
  }

  /* Fail-visible: anything already on screen is shown, never hidden retroactively. */
  function reveals() {
    function tick() {
      var limit = innerHeight * 0.94;
      Array.prototype.forEach.call(document.querySelectorAll('[data-reveal]'), function (el) {
        if (el.dataset.shown) return;
        var below = el.getBoundingClientRect().top >= limit;
        if (!el.dataset.armed) { el.dataset.armed = '1'; if (below) el.classList.add('is-hidden'); }
        if (!below) { el.classList.remove('is-hidden'); el.dataset.shown = '1'; }
      });
    }
    tick();
    addEventListener('scroll', tick, { passive: true });
    addEventListener('resize', tick, { passive: true });
    setInterval(tick, 160);
  }

  /* Hover turns the right X 45 degrees; click reveals the code; click the panel to copy. */
  function discount() {
    var trigger = document.querySelector('.evf-x-trigger');
    var panel = document.querySelector('.evf-disc');
    if (!trigger || !panel) return;
    var note = panel.querySelector('.evf-disc__note');
    var idle = note ? note.textContent : '';
    trigger.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open && note) note.textContent = idle;
    });
    var inner = panel.querySelector('.evf-disc__inner');
    if (!inner) return;
    inner.addEventListener('click', function () {
      var el = panel.querySelector('.evf-disc__code');
      var code = el ? el.textContent.replace(/^\s*code\s*/i, '').trim() : '';
      if (navigator.clipboard && code) navigator.clipboard.writeText(code);
      if (note) note.textContent = 'Copied to clipboard';
    });
  }

  /* ENTER THE VIEW opens the storefront password field. */
  function gate() {
    var trigger = document.querySelector('.evf-gate__enter-trigger');
    var field = document.querySelector('.evf-gate__pw');
    if (!trigger || !field) return;
    if (field.querySelector('.evf-errors li')) field.classList.add('is-open');
    trigger.addEventListener('click', function () {
      var open = field.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var i = field.querySelector('input[type=password]'); if (i) i.focus(); }
    });
  }

  /* Options -> variant id, availability and price. */
  function variants() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-variant-picker]'), function (root) {
      var data = root.querySelector('[data-variant-json]');
      if (!data) return;
      var list = JSON.parse(data.textContent);
      var idInput = root.querySelector('input[name="id"]');
      var priceEl = root.querySelector('[data-price]');
      var btn = root.querySelector('[data-add]');
      var note = root.querySelector('[data-note]');
      function sync() {
        var sel = Array.prototype.map.call(root.querySelectorAll('[data-option-group]'), function (g) {
          var on = g.querySelector('[aria-pressed="true"]');
          return on ? on.getAttribute('data-value') : null;
        });
        if (sel.indexOf(null) > -1) {
          if (btn) btn.disabled = true;
          return;
        }
        var match = list.filter(function (v) {
          return sel.every(function (o, i) { return v.options[i] === o; });
        })[0];
        if (!match) { if (note) note.textContent = 'Unavailable in this combination'; if (btn) btn.disabled = true; return; }
        if (idInput) idInput.value = match.id;
        if (priceEl && match.price) priceEl.textContent = match.price;
        if (btn) { btn.disabled = !match.available; btn.textContent = match.available ? btn.getAttribute('data-label') : 'Sold out'; }
        if (note) note.textContent = '';
      }
      Array.prototype.forEach.call(root.querySelectorAll('[data-option-group] button'), function (b) {
        b.addEventListener('click', function () {
          Array.prototype.forEach.call(b.parentElement.querySelectorAll('button'), function (o) {
            o.setAttribute('aria-pressed', 'false');
          });
          b.setAttribute('aria-pressed', 'true');
          sync();
        });
      });
      sync();
    });
  }

  function init() { cursor(); reveals(); discount(); gate(); variants(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
